module.exports = __webpack_public_path__ + "assets/img/DATA_EXPORT_PLUGIN.862bb302.svg";